let env = {};

env.baseURL = 'https://api.hml.invitee.com.br/api/v1/';
env.normalURL = 'https://api.hml.invitee.com.br/';

export default env



// WEBPACK FOOTER //
// ./src/config/env.js